// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2299":"4fccf76d","3356":"20ce9fbe"}[chunkId] + ".chunk.css";
};